module.exports = __webpack_public_path__ + "img/logo-perki.cb4b9e15.svg";